import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

class Button extends React.Component {
  static displayName = "Button";

  static propTypes = {
    href: PropTypes.string,
    type: PropTypes.oneOf(["default", "action", "secondary", "destroy", "toggle"]),
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    hideDropShadow: PropTypes.bool,
    className: PropTypes.string,
    forwardedRef: PropTypes.any,
    buttonType: PropTypes.string,
  };

  static defaultProps = {
    type: "default",
    hideDropShadow: false,
    buttonType: "button",
  };

  state = {
    pressed: false,
  };

  handleClick = e => {
    if (!this.props.disabled) {
      if (this.props.type === "toggle") this.setState({ pressed: true });
      if (this.props.onClick) this.props.onClick(e);
    }
  };

  handleBlur = () => {
    if (this.props.type === "toggle") this.setState({ pressed: false });
  };

  render() {
    let style_class = "et--button";
    if (this.props.type !== "default") {
      style_class += `-${this.props.type}`;
    }

    const classes = classNames(this.props.className, style_class, {
      "is-fixed": this.props.fixed,
      "is-disabled": this.props.disabled,
      "is-without-dropshadow": this.props.hideDropShadow,
    });

    const [onBlur, ariaPressed] = this.props.type === "toggle" ? [this.handleBlur, this.state.pressed] : [];

    return this.props.href ? (
      <a
        ref={this.props.forwardedRef}
        href={this.props.href}
        className={classes}
        disabled={this.props.disabled}
        onClick={this.handleClick}
      >
        {this.props.children}
      </a>
    ) : (
      <button
        ref={this.props.forwardedRef}
        className={classes}
        disabled={this.props.disabled}
        onClick={this.handleClick}
        onBlur={onBlur}
        aria-pressed={ariaPressed}
        type={this.props.buttonType}
      >
        {this.props.children}
      </button>
    );
  }
}

const wrapped = (props, ref) => <Button {...props} forwardedRef={ref} />;

wrapped.displayName = "Button.RefWrapper";

export default React.forwardRef(wrapped);
